//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

//Clinic Recalls
const getClinicSettings = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/recalls/settings")
}
const saveSettings = (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/recalls/settings",data)
}
const getClinicTimings= (clinicId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/recalls/recall-timings")
}
const saveClinicTimings= (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/recalls/recall-timings",data)
}

//Admin Recalls

const buildRecallQuery = ({ sortBy, sortOrder, searchField, searchTerm, statusFilter }) => {
    const parts = [];
    if (sortBy) {
        parts.push(`sortBy==${sortBy}`);
    }
    if (sortOrder) {
        parts.push(`sortOrder==${sortOrder}`);
    }
    if (searchTerm?.trim()) {
        const field = searchField || 'title';
        parts.push(`${field}==*${searchTerm.trim()}*`);
    }
    if (statusFilter) {
        parts.push(`status==${statusFilter}`);
    }
    return parts.join(',');
};

const getRecallRequests = (pageNo = 0, pageSize = 10, queryOptions = {}) => {
    const q = buildRecallQuery(queryOptions);
    return axios.get(API_URL + 'recalls/requests', {
        params: {
            pageNo,
            pageSize,
            ...(q ? { q } : {}),
        },
    });
};

const getRecalls = (pageNo = 0, pageSize = 10, queryOptions = {}) => {
    return getRecallRequests(pageNo, pageSize, queryOptions);
};
const getRecallsById = (recallId) => {
    return axios.get(API_URL + 'recalls/requests/' + recallId);
};

const getRecallRequestById = (recallId) => getRecallsById(recallId);

const updateRecall = (recallId, data) => {
    return axios.put(API_URL + 'recalls/requests/' + recallId, data);
};

const updateRecallRequestById = (recallId, data) => updateRecall(recallId, data);

const downloadRecallRequestFile = (clinicId, reqId) => {
    return axios.get(API_URL + `recalls/${clinicId}/requests/${reqId}/downloads`, {
        responseType: 'blob',
    });
};

const uploadRecallFileToProcess = (reqId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(API_URL + `recalls/requests/${reqId}/file-to-process`, formData, {
        isMultipart: true,
    });
};

const processRecallFile = (clinicId, reqId) => {
    return axios.post(API_URL + `recalls/${clinicId}/requests/${reqId}/process-file`);
};

const startRecallMatchJob = (reqId, file, groups) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('groups', JSON.stringify(groups));
    return axios.post(API_URL + `recalls/requests/${reqId}/match-jobs`, formData, {
        isMultipart: true,
    });
};

const getRecallMatchJob = (reqId, jobId) => {
    return axios.get(API_URL + `recalls/requests/${reqId}/match-jobs/${jobId}`);
};

const getLatestRecallMatchJob = (reqId) => {
    return axios.get(API_URL + `recalls/requests/${reqId}/match-jobs/latest`);
};

const downloadRecallMatchJobResult = (reqId, jobId) => {
    return axios.get(API_URL + `recalls/requests/${reqId}/match-jobs/${jobId}/result`, {
        responseType: 'blob',
    });
};

const fileDownload = (fileUrl) => {
    return axios.get(fileUrl, {
        responseType: 'blob',
    });
};

const buildRecallPoolQuery = ({ sortBy, sortOrder, searchField, searchTerm, statusFilter }) => {
    const parts = [];
    if (sortBy) {
        parts.push(`sortBy==${sortBy}`);
    }
    if (sortOrder) {
        parts.push(`sortOrder==${sortOrder}`);
    }
    if (searchTerm?.trim()) {
        const field = searchField || 'lastName';
        parts.push(`${field}==*${searchTerm.trim()}*`);
    }
    if (statusFilter) {
        parts.push(`status==${statusFilter}`);
    }
    return parts.join(',');
};

const getRecallPools = (pageNo = 0, pageSize = 10, queryOptions = {}) => {
    const q = buildRecallPoolQuery(queryOptions);
    return axios.get(API_URL + 'recalls/pools', {
        params: {
            pageNo,
            pageSize,
            ...(q ? { q } : {}),
        },
    });
};

const getRecallPoolById = (poolId) => axios.get(API_URL + 'recalls/pools/' + poolId);

const updateRecallPool = (poolId, data) => axios.put(API_URL + 'recalls/pools/' + poolId, data);

const deleteRecallPool = (poolId) => axios.delete(API_URL + 'recalls/pools/' + poolId);

const recallsService = {
   getClinicSettings,
   saveSettings,
   getClinicTimings,
   saveClinicTimings,
   getRecalls,
   getRecallRequests,
   getRecallsById,
   getRecallRequestById,
   updateRecall,
   updateRecallRequestById,
   downloadRecallRequestFile,
   uploadRecallFileToProcess,
   processRecallFile,
   startRecallMatchJob,
   getRecallMatchJob,
   getLatestRecallMatchJob,
   downloadRecallMatchJobResult,
   fileDownload,
   getRecallPools,
   getRecallPoolById,
   updateRecallPool,
   deleteRecallPool,
}

export default recallsService;
